import React from 'react'
import { useHistory, Link } from 'react-router-dom'
import {
  Container,
  FormLabel,
  FormDashboardInput as FormInput,
  InputPrefix,
  BasicDropdown,
  FormDashboardTextarea,
  Checkbox,
  ButtonSecondary,
  FormRow,
  PinPointInput
} from '../../../components'
import styles from './main-content.module.css'

const MainContent = () => {
  const history = useHistory()

  return (
    <Container>
      <div className="flex flex-wrap pt-8 pb-16 lg:pt-20 lg:pb-24 justify-center">
        <main className="w-full md:w-8/12 lg:w-6/12">
          <p className="text-sm text-gray-444 mb-10">If you are a nonprofit , school, faith-based, government or civic organization that would like to partner with us to recruit and manage volunteers, please complete the information below.</p>

          <form onSubmit={() => history.push('/register-organization-confirmation')}>
            <div className={styles.section}>
              <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">Basic Information</h2>

              <FormRow>
                <FormLabel>Enter your organization's URL</FormLabel>
                <InputPrefix prefix="khub.org" />
              </FormRow>

              <FormRow>
                <FormLabel>Organization Name</FormLabel>
                <FormInput className="w-full" />
              </FormRow>

              <div className="flex flex-wrap -mx-4">
                <div className="w-full md:w-6/12 px-4">
                  <FormRow>
                    <FormLabel>Approach</FormLabel>
                    <BasicDropdown
                      placeholder="Choose Approach"
                      options={[
                        { value: 'Approach 1', label: 'Approach 1' },
                        { value: 'Approach 2', label: 'Approach 2'},
                      ]}
                    />
                  </FormRow>
                </div>
                <div className="w-full md:w-6/12 px-4">
                  <FormRow>
                    <FormLabel>Issues</FormLabel>
                    <BasicDropdown
                      placeholder="Issues"
                      options={[
                        { value: 'Issue 1', label: 'Issue 1' },
                        { value: 'Issue 2', label: 'Issue 2'},
                      ]}
                    />
                  </FormRow>
                </div>
              </div>

              <FormRow>
                <FormLabel>Mission Statement</FormLabel>
                <FormDashboardTextarea className="w-full" rows={5} placeholder="Please describe your mission statement" />
              </FormRow>
            </div>

            <div className={styles.section}>
              <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">Organization Contact Info</h2>

              <FormRow>
                <FormLabel>Website</FormLabel>
                <FormInput className="w-full" placeholder="Enter Website" />
              </FormRow>

              <FormRow>
                <FormLabel>Phone Number</FormLabel>
                <FormInput className="w-full" placeholder="Enter phone number" />
              </FormRow>

              <FormRow>
                <FormLabel>Province</FormLabel>
                <BasicDropdown
                  placeholder="Select Province"
                  options={[
                    { value: 'Jawa Barat', label: 'Jawa Barat' },
                    { value: 'DKI Jakarta', label: 'DKI Jakarta'},
                  ]}
                />
              </FormRow>

              <FormRow>
                <FormLabel>City</FormLabel>
                <BasicDropdown
                  placeholder="Select City"
                  options={[
                    { value: 'Bandung', label: 'Bandung' },
                    { value: 'Jakarta', label: 'Jakarta'},
                  ]}
                />
              </FormRow>

              <FormRow>
                <FormLabel>Address</FormLabel>
                <FormInput className="w-full" placeholder="Enter Address" />
              </FormRow>

              <FormRow>
                <FormLabel>Pin Point</FormLabel>
                <PinPointInput />
              </FormRow>
            </div>

            <div className={styles.section}>
              <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">Account Information</h2>

              <FormRow>
                <FormLabel>Email</FormLabel>
                <FormInput className="w-full" placeholder="Enter Email" type="email" />
              </FormRow>

              <FormRow>
                <FormLabel>Password</FormLabel>
                <FormInput className="w-full" placeholder="Enter Password" type="password" />
              </FormRow>
            </div>

            <div className={styles.section}>
              <Checkbox rounded label={<span>By clicking submit you are agreeing to the <Link to="/terms-conditions" className="underline">Terms and Conditions</Link></span>} />
            </div>

            <ButtonSecondary>Submit Now</ButtonSecondary>
          </form>
        </main>
      </div>
    </Container>
  )
}

export { MainContent }
